export const abbreviateLeagueName = (league: string): string => {
    return league.split(" ")[0]
}
